export default {
  suspiciousType: 'Suspicious Type',
  plant: 'Plant',
  nfcUid: 'NFC UID',
  operationDate: 'Operation Date',
  operation: 'Operation',
  blockReason: 'Block Reason',
  printNfcId: 'Please enter NFC UID',
  warningContent: 'The time range cannot exceed 31 days. Please select the time again.'
}
